import React from 'react';
import {
  withStyles,
  createStyles,
  WithStyles,
  Theme,
} from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import classNames from 'classnames';

import { ITable } from '../../../../types/IRestaurantTablesStore';
import { parseTableHall } from '../../../../helpers/bookingHelpers';

const styles = (theme: Theme) => createStyles({
  wrap: {
    display: 'flex',
    height: 85,
    flex: 1,
    borderRadius: 10,
    border: '1px solid rgba(0, 0, 0, 0.54)',
    alignItems: 'center',
    justifyContent: 'center',
    position: 'relative',
    cursor: 'pointer',
    backgroundColor: '#ffffff',
    // Компактные размеры для мобильных и планшетов
    [theme.breakpoints.down(465)]: {
      height: 60,
      borderRadius: 8,
    },
    [theme.breakpoints.only('sm')]: {
      height: 70,
      borderRadius: 8,
    },
  },
  numberWrap: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    textAlign: 'center',
  },
  number: {
    margin: theme.spacing(),
    [theme.breakpoints.down(465)]: {
      margin: theme.spacing(0.5),
    },
    [theme.breakpoints.only('sm')]: {
      margin: theme.spacing(0.75),
    },
  },
  hallLabel: {
    fontSize: 12,
    [theme.breakpoints.down(465)]: {
      fontSize: 10,
    },
    [theme.breakpoints.only('sm')]: {
      fontSize: 11,
    },
  },
  tableNumber: {
    [theme.breakpoints.down(465)]: {
      fontSize: '1.1rem !important',
    },
    [theme.breakpoints.only('sm')]: {
      fontSize: '1.2rem !important',
    },
  },
  marker: {
    backgroundColor: theme.palette.primary.main,
    width: 25,
    height: 25,
    position: 'absolute',
    borderRadius: 60,
    alignItems: 'center',
    justifyContent: 'center',
    display: 'flex',
    color: 'white',
    top: -10,
    right: -10,
    [theme.breakpoints.down(465)]: {
      width: 20,
      height: 20,
      top: -8,
      right: -8,
      fontSize: '0.75rem',
    },
    [theme.breakpoints.only('sm')]: {
      width: 22,
      height: 22,
      top: -9,
      right: -9,
    },
  },
  active: {
    border: '2px solid rgba(0, 0, 0, 0.87)',
    backgroundColor: '#6ae9c5',
  },
  // disabled: {
  //   backgroundColor: '#707070',
  // },
});

interface IProps extends WithStyles<typeof styles> {
  table: ITable;
  handleSelect: (table: ITable) => void;
  active: boolean;
  // disabled: boolean;
}

function RestaurantIcon(props: IProps) {
  const {
    classes,
    handleSelect,
    active,
    table,
    // disabled,
  } = props;

  // const onClick = () => !disabled && handleSelect(table);
  const onClick = () => handleSelect(table);

  return (
    <div
      onClick={onClick}
      className={classNames(classes.wrap, {
        [classes.active]: active,
        // [classes.disabled]: disabled,
      })}
    >
      <div className={classes.numberWrap}>
        <Typography className={classNames(classes.number, classes.hallLabel)}>
          {parseTableHall(table.hall)}
        </Typography>
        <Typography variant="h6" className={classes.tableNumber}>
          {table.number}
        </Typography>
      </div>
    </div>
  );
}

export default withStyles(styles)(RestaurantIcon);
